import { PremiumTagShell } from './premium-tag-shell';
import shellStyle from './premium-tag-shell.module.css';
import temuLogo from './temu-logo.svg';
import { TEMU_COLOR } from './temu-constants';
import { messages } from './messages';
import { FormattedMessage } from 'react-intl';

export const TemuPreSaleTag = () => {
  return (
    <PremiumTagShell color={TEMU_COLOR} logo={<img alt='' className={shellStyle['tag-logo']} src={temuLogo} />}>
      <FormattedMessage {...messages.temuPreSaleLabel} />
    </PremiumTagShell>
  );
};
